import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const getCoinDetails = async ({ 
  impulse_type, 
  base_asset_id, 
  base_asset_type, 
  compare_asset_id, 
  compare_asset_type 
}) => {
  const params = new URLSearchParams({
    base_asset_id,
    base_asset_type,
    compare_asset_id,
    compare_asset_type
  });

  const url = `${backendUrl}/api/screener/compare/${impulse_type}/?${params}`;

  const response = await fetchWithAuth(url, {
    headers: { 'Content-Type': 'application/json' }
  });

  if (!response.ok) {
    throw new Error(`Ошибка сети при получении импульсов: ${response.status}`);
  }

  return response.json();
};